import React, { Component } from 'react'
import LISTS from '../../constants/common/FooterLists'

export class Footer extends Component {
    renderList(list) {
        return (
            <div className="footerListCont">
                <span className="footerTitleStyle">{list.title}</span>
                {list.elements.map(e => {
                    return <a className={"footerListElement"} key={e.name} href={e.link}>{e.name}</a>
                })}
            </div>
        )
    }

    render() {
        return (
            <div className="mainFooter">
                <div className="footerTopCont">
                    {LISTS.map(list => this.renderList(list))}
                </div>

                <div className="footerMiddleCont">
                    <p style={{ color: '#fff', fontSize: '0.8rem'}}>Copyright © 2021 Moneris Solutions Corporation, All Rights Reserved</p>
                    <div style={{ width: 'auto', display: 'flex', flexDirection: 'row' }}>
                        <a className="footerBtn" href="https://www.moneris.com/Legal/Privacy-Policy#PrivacyPolicy">{"PRIVACY POLICY"}</a>
                        <a className="footerBtn" href="https://developer.moneris.com/Agreements/Terms%20of%20Use">{"TERMS OF USE"}</a>
                        <a className="footerBtn" href="http://www.moneris.com/">{"MONERIS.COM"}</a>
                    </div>
                </div>

                <div style={{width: '100%' ,marginLeft: '1vw', marginRight: '1vw'}}>
                    <p className="footerBottmTxt">{"Â®MONERIS and MONERIS & Design are registered trade-marks of Moneris Solutions Corporation. VISA is a registered trade-mark of Visa International. MASTERCARD and MASTERCARD SECURECODE are registered trade-marks of MasterCard International Incorporated. DISCOVER is a registered trade-mark of Discover Financial Services. AMERICAN EXPRESS and AMERICAN EXPRESS SAFEKEY are registered trade-marks of American Express Company. INTERAC is a registered trade-mark of Interac Inc. Apple, the Apple logo, Apple Pay and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries."}</p>
                    <p className="footerBottmTxt">{"â„¢MONERIS BE PAYMENT READY & Design is a trade-mark of Moneris Solutions Corporation. ANDROID is a trademark of Google Inc. MASTERPASS is a trade-mark of MasterCard International Inc."}</p>
                    <p className="footerBottmTxt">{"All other marks or registered trade-marks are the property of their respective owners."}</p>
                </div>
            </div>
        );
    }
}

export default Footer
